import React from "react";
import { Container, Row, Col } from "reactstrap";

export default () => {
  return (
    <div className="footer">
      <Container fluid>
        <Row>
          <Col md={6}>
            2019 - 2020 &copy; <a href="https://napaautomative.com"> Napa Automative</a>
          </Col>
          <Col md={6}>
            <div className="text-md-right footer-links d-none d-sm-block">
              <a href="https://napaautomative.com">About Us</a>
              <a href="https://napaautomative.com">Help</a>
              <a href="https://napaautomative.com">Contact Us</a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
